'use client';

import { Box } from '@mui/material';
import type * as layout from '@ocodelib/compose-layout';
import { createColorVariables } from '@repo-foundation/util/mui-theme-generate-colors';
import type { IAppConfig } from '@repo/js-basic-app';
import { PLUGIN_KEYS } from '@repo/js-basic-app';
import type { P5BasicAppType } from '@repo/p5-basic-app';
import type { IProjectLoader, ProjectFile } from '@repo/project-interface';
import dynamic from 'next/dynamic';
import type { CSSProperties } from 'react';
import { useMemo } from 'react';
import { config } from '../../config';
import { CUSTOM_PALETTES, P5_PALETTE } from '../../theme/custom-palette';
import { WorkspaceTopbar } from './components/WorkspaceTopbar';

const P5BasicAppUi = dynamic(() => import('@repo/p5-basic-app').then((m) => m.P5BasicAppUi), {
  ssr: false,
});

interface Props {
  previewMode?: boolean;
  onLoadApp?: (app: P5BasicAppType | null) => void;
  newProjectLoader?: IProjectLoader<ProjectFile[]>;
  initialProjectLoader?: IProjectLoader<ProjectFile[]>;
}

export function P5BasicAppLoader(props: Props) {
  const { onLoadApp, previewMode = false, newProjectLoader, initialProjectLoader } = props;
  const style = useMemo(
    () =>
      ({
        ...createColorVariables('primary', P5_PALETTE),
        ...createColorVariables('secondary', CUSTOM_PALETTES.cyan),
      }) as CSSProperties,
    [],
  );
  // const workspaceTheme = useWorkspaceTheme();
  const appConfig = useMemo<IAppConfig>(
    () => ({
      apiBaseURL: config.apiBaseURL,
      datiBaseURL: config.datiBaseURL,
      previewMode,
      newProjectLoader,
      initialProjectLoader,
    }),
    [previewMode, newProjectLoader, initialProjectLoader],
  );

  return (
    <Box style={style}>
      <P5BasicAppUi
        onLayoutBuild={previewMode ? undefined : overrideLayout}
        appConfig={appConfig}
        onLoadApp={onLoadApp}
      />
    </Box>
  );
}

function overrideLayout(layoutManager: layout.ComposeLayoutManager) {
  function reg(key: string, component: React.ReactElement) {
    return layoutManager.registerPlugin(key, component);
  }
  reg(PLUGIN_KEYS.root.topBar, <WorkspaceTopbar />);
}
